import type { CSSProperties, SVGProps } from 'react'
import classes from './icon.module.css'

export type BuildCircleProps = SVGProps<SVGSVGElement> & {
  className?: string
  style?: CSSProperties
}
export function BuildCircle(props: BuildCircleProps) {
  const { className, style, ...rest } = props

  const cls = `${classes.root} ${className || ''}`
  return (
    <svg
      aria-hidden="true"
      className={cls}
      focusable="false"
      viewBox="0 0 24 24"
      {...rest}
      data-testid="DoubleArrowIcon"
      style={style}
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m4.9 13.49-1.4 1.4c-.2.2-.51.2-.71 0l-3.41-3.41c-1.22.43-2.64.17-3.62-.81-1.11-1.11-1.3-2.79-.59-4.1l2.35 2.35 1.41-1.41-2.35-2.34c1.32-.71 2.99-.52 4.1.59.98.98 1.24 2.4.81 3.62l3.41 3.41c.19.19.19.51 0 .7"
        fillRule="evenodd"
      />
    </svg>
  )
}
